import React from 'react';
import { Sparkles, CheckCircle2 } from 'lucide-react';
export function SummerCampWhatKindOfCamp() {
  return <section className="py-20 bg-paper border-y border-subtle-gray" data-id="element-3346">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-3347">
        <div className="bg-off-white rounded-2xl p-8 md:p-12 border border-subtle-gray" data-id="element-3348">
          <div className="inline-flex items-center gap-2 bg-storm-red/10 text-storm-red px-4 py-1.5 rounded-full text-sm font-bold uppercase tracking-wide mb-4" data-id="element-3349">
            <Sparkles className="w-4 h-4" data-id="element-3350" />
            Good to Know
          </div>
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-3351">
            What Kind of Camp Is This?
          </h2>
          <p className="text-lg text-gray-warm mb-8 leading-relaxed" data-id="element-3352">
            Storm Summer Camp is an active kids camp hosted inside the Storm
            Taekwondo facility. Campers will enjoy games, movement, activities,
            and some taekwondo-themed games, but this is not a structured
            taekwondo class or formal martial arts training program.
          </p>
          <ul className="grid sm:grid-cols-2 gap-4" data-id="element-3353">
            {['Active kids camp inside the Storm Taekwondo facility', 'Games, movement and structured camp activities', 'Some taekwondo-themed games', 'No formal taekwondo training or belt curriculum during camp'].map((item, idx) => <li key={idx} className="flex items-start gap-3 bg-paper p-4 rounded-xl border border-subtle-gray" data-id="element-3354">
                <CheckCircle2 className="w-5 h-5 text-storm-red shrink-0 mt-0.5" data-id="element-3355" />
                <span className="text-ink font-bold text-sm" data-id="element-3356">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}